import { FlagState } from '../components/FeatureFlag';

export const getExperiments = (flags: Partial<FlagState>): Partial<FlagState> => {
  return Object.fromEntries(Object.entries(flags).map(([key, value]) => [key, String(value)]));
};
